
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import FuzokuMeisaiJunsokuMenu from '@/views/components/FuzokuMeisaiJunsokuMenu.vue'
import FuzokuMeisaiKaikeiKijunMenu from '@/views/components/FuzokuMeisaiKaikeiKijunMenu.vue'
import TaishakuTaishoMenu from '@/views/components/TaishakuTaishoMenu.vue'
import SonekiKeisanMenu from '@/views/components/SonekiKeisanMenu.vue'
import KeieiInfoMenu from '@/views/components/KeieiInfoMenu.vue'

export default defineComponent({
  components: {
    FuzokuMeisaiKaikeiKijunMenu,
    FuzokuMeisaiJunsokuMenu,
    TaishakuTaishoMenu,
    SonekiKeisanMenu,
    KeieiInfoMenu
  },
  setup () {
    const store = useStore()
    const userStatus = computed(() => store.state.userStatus)

    return {
      userStatus
    }
  }
})
